import lf from 'lovefield'

export function exo_mouvements (schemaBuilder) {
  schemaBuilder.createTable('exo_mouvements')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('code', lf.Type.STRING)
      .addColumn('exo_chantiers_id', lf.Type.INTEGER)
      .addColumn('exo_cubatures_depart_id', lf.Type.INTEGER)
      .addColumn('exo_cubatures_arrivee_id', lf.Type.INTEGER)
      .addColumn('volume', lf.Type.INTEGER)
      .addColumn('distance', lf.Type.INTEGER)
      .addColumn('const_sol_id', lf.Type.INTEGER)
      .addColumn('preparationtraitementdemande', lf.Type.STRING)
      .addColumn('transformationdemandee', lf.Type.STRING)
      .addColumn('stopautoavant', lf.Type.INTEGER)
      .addColumn('stopautoapres', lf.Type.INTEGER)
      .addColumn('reglage', lf.Type.INTEGER)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id']);
      // .addUnique('code', ['code'])
}

/*
CREATE TABLE IF NOT EXISTS `exo-mouvements` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(4) NOT NULL,
  `exo-cubatures-depart_id` int(11) NOT NULL,
  `exo-cubatures-arrivee_id` int(11) NOT NULL,
  `volume` int(11) NOT NULL COMMENT 'm3',
  `distance` int(11) NOT NULL COMMENT 'm',
  `const-sols_code` int(11) NOT NULL,
  `preparationtraitementdemande` varchar(4) NOT NULL COMMENT 'oui / non / pe (peut-être) ',
  `transformationdemandee` varchar(4) NOT NULL COMMENT 'oui / non / pe (peut-être)',
  `stopautoavant` tinyint(1) NOT NULL DEFAULT '0' COMMENT 'oui (1) / non (0)',
  `stopautoapres` tinyint(1) NOT NULL DEFAULT '1' COMMENT 'oui (1) / non (0)',
  `reglage` tinyint(1) NOT NULL,
  `description` text NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/exoMouvements.schema.js